const pageNameKey = "shotTable";

export const shotTableEn = {
  [pageNameKey]: {
    title: "Shot Analyzer",
    noDataAvailable: "No data available",
    measurementLoadError: "Failed to load measurement data",
  },
};

export const shotTablePtBr = {
  [pageNameKey]: {
    title: "Analisador de Shot",
    noDataAvailable: "Sem dados disponíveis",
    measurementLoadError: "Falha ao carregar os dados de medição",
  },
};

export const shotTableDe = {
  [pageNameKey]: {
    title: "Shot-Analysator",
    noDataAvailable: "Keine Daten verfügbar",
    measurementLoadError: "Messdaten konnten nicht geladen werden",
  },
};

export const shotTableZhHans = {
  [pageNameKey]: {
    title: "Shot 分析器",
    noDataAvailable: "暂无可用数据",
    measurementLoadError: "加载测量数据失败",
  },
};

export const shotTableEs = {
  [pageNameKey]: {
    title: "Analizador de Shot",
    noDataAvailable: "No hay datos disponibles",
    measurementLoadError: "No se pudieron cargar los datos de medición",
  },
};

export const shotTableIt = {
  [pageNameKey]: {
    title: "Analizzatore Shot",
    noDataAvailable: "Nessun dato disponibile",
    measurementLoadError: "Impossibile caricare i dati di misurazione",
  },
};

export const shotTableNl = {
  [pageNameKey]: {
    title: "Shot-analysator",
    noDataAvailable: "Geen gegevens beschikbaar",
    measurementLoadError: "Meetgegevens konden niet worden geladen",
  },
};

export const shotTableTr = {
  [pageNameKey]: {
    noDataAvailable: "Veri yok",
    title: "Atış Analizörü",
    measurementLoadError: "Ölçüm verileri yüklenemedi",
  },
};
